import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { RequirementsService } from '../../../services/requirements.service';
import { Requirement } from '../../../models/requirement.model';

@Component({
  selector: 'app-requirement-link-block',
  imports: [TranslatePipe, MatProgressSpinner],
  templateUrl: './requirement-link-block.component.html',
  styleUrl: './requirement-link-block.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequirementLinkBlockComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly requirementsService = inject(RequirementsService);

  readonly projectId = input.required<string>();
  readonly requirementId = input.required<string | null>();

  readonly loading = signal(false);
  readonly loadError = signal(false);
  readonly requirement = signal<Requirement | null>(null);

  constructor() {
    effect(() => {
      const id = this.requirementId();
      if (!id) {
        this.requirement.set(null);
        this.loadError.set(false);
        this.loading.set(false);
        return;
      }
      this.loadRequirement(id);
    });
  }

  private loadRequirement(id: string): void {
    this.loading.set(true);
    this.loadError.set(false);
    this.requirementsService
      .getById(this.projectId(), id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (requirement) => {
          this.requirement.set(requirement);
          this.loading.set(false);
        },
        error: () => {
          this.loadError.set(true);
          this.loading.set(false);
        },
      });
  }
}
